// Refresh on first use, then only when someone interacts with a stale view.
// Expiry never starts a request by itself. Explicit refreshes (e.g. after a
// mutation) bypass the TTL and coalesce while a previous request is running.
export function startDemandRefresh(
  task: () => void | Promise<void>,
  ttlMs: number | (() => number),
  { immediate = true }: { immediate?: boolean } = {},
) {
  let stopped = false
  let running = false
  let dirty = immediate
  let lastCompletedAt = Date.now()

  function refresh() {
    dirty = true
    check()
  }

  function check() {
    if (stopped || document.hidden || running) return
    const ttl = typeof ttlMs === 'function' ? ttlMs() : ttlMs
    if (!dirty && Date.now() - lastCompletedAt < ttl) return
    dirty = false
    running = true
    void Promise.resolve()
      .then(() => {
        if (!stopped && !document.hidden) return task()
        dirty = true
      })
      .catch((error) => console.error('Demand refresh failed:', error))
      .finally(() => {
        lastCompletedAt = Date.now()
        running = false
        if (dirty) check()
      })
  }

  document.addEventListener('visibilitychange', check)
  document.addEventListener('pointerdown', check)
  document.addEventListener('keydown', check)
  window.addEventListener('focus', check)
  if (immediate) check()

  return {
    refresh,
    stop() {
      stopped = true
      document.removeEventListener('visibilitychange', check)
      document.removeEventListener('pointerdown', check)
      document.removeEventListener('keydown', check)
      window.removeEventListener('focus', check)
    },
  }
}
